import { WebshopCategoryDetail } from '@cldsystems/ws-api-client';

type BreadcrumbsType = {
  label: string;
  url: string;
}[];

export const getCategoryBreadcrumbs = (category: WebshopCategoryDetail) => {
  const result: BreadcrumbsType = [];

  category.superCategories.forEach(item => {
    result.push({
      label: item.name,
      url: `/products/${item.url}`,
    });
  });

  result.push({
    label: category.name,
    url: `/products/${category.meta.url}`,
  });

  return result;
};
